import {
  BriefcaseBusiness, Handshake, Users, UserRound, Music, Mic, Headphones, Radio,
  Camera, Video, Megaphone, Globe, CalendarDays, Ticket, Plane, MapPin, Star,
  Sparkles, ShieldCheck, ChartNoAxesCombined, Lightbulb, Palette, Wrench, Building2,
} from 'lucide-react';

export const SERVICE_ICONS = {
  BriefcaseBusiness: { label: 'Business', icon: BriefcaseBusiness },
  Handshake: { label: 'Partnerships', icon: Handshake },
  Users: { label: 'Team', icon: Users },
  UserRound: { label: 'Artist', icon: UserRound },
  Music: { label: 'Music', icon: Music },
  Mic: { label: 'Performance', icon: Mic },
  Headphones: { label: 'Audio', icon: Headphones },
  Radio: { label: 'Radio', icon: Radio },
  Camera: { label: 'Photography', icon: Camera },
  Video: { label: 'Video', icon: Video },
  Megaphone: { label: 'Promotion', icon: Megaphone },
  Globe: { label: 'Global', icon: Globe },
  CalendarDays: { label: 'Events', icon: CalendarDays },
  Ticket: { label: 'Booking', icon: Ticket },
  Plane: { label: 'Touring', icon: Plane },
  MapPin: { label: 'Locations', icon: MapPin },
  Star: { label: 'Talent', icon: Star },
  Sparkles: { label: 'Creative', icon: Sparkles },
  ShieldCheck: { label: 'Rights', icon: ShieldCheck },
  ChartNoAxesCombined: { label: 'Growth', icon: ChartNoAxesCombined },
  Lightbulb: { label: 'Strategy', icon: Lightbulb },
  Palette: { label: 'Design', icon: Palette },
  Wrench: { label: 'Production', icon: Wrench },
  Building2: { label: 'Company', icon: Building2 },
};

export type ServiceIconName = keyof typeof SERVICE_ICONS;
export interface ServiceIcon {
  mode: 'none' | 'library' | 'upload';
  name: ServiceIconName | '';
  imageUrl: string;
}

export const EMPTY_SERVICE_ICON: ServiceIcon = { mode: 'none', name: '', imageUrl: '' };

export function isServiceIconName(value: unknown): value is ServiceIconName {
  return typeof value === 'string' && Object.hasOwn(SERVICE_ICONS, value);
}

export function serviceIconPayload(value: unknown): ServiceIcon {
  if (!value || typeof value !== 'object' || !('mode' in value)) {
    throw new Error('Choose an icon mode.');
  }
  if (value.mode === 'none') return { ...EMPTY_SERVICE_ICON };
  if (value.mode === 'library' && 'name' in value && isServiceIconName(value.name)) {
    return { mode: 'library', name: value.name, imageUrl: '' };
  }
  if (value.mode === 'upload' && 'imageUrl' in value && typeof value.imageUrl === 'string'
    && URL.canParse(value.imageUrl) && new URL(value.imageUrl).protocol === 'https:') {
    return { mode: 'upload', name: '', imageUrl: value.imageUrl.trim() };
  }
  throw new Error(value.mode === 'upload' ? 'Upload an icon before saving.' : 'Choose an icon from the library.');
}
